module.exports = __webpack_public_path__ + "static/media/cloud-eco-ecology-svgrepo-com.95903213.svg";